import { useEffect, useState } from "react";

const navItems = [
  { label: "今日更新", href: "#updates" },
  { label: "热播剧", href: "#series" },
  { label: "电影推荐", href: "#movies" },
  { label: "蓝光画质", href: "#bluray" },
  { label: "高分片单", href: "#playlists" },
  { label: "资源库", href: "#library" },
  { label: "找片指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/20 text-background-50"
            }`}
          >
            <i className="ri-film-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg font-semibold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            茶杯狐影视
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-100/90 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#library"
          className="hidden lg:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-search-line"></i>
          开始找片
        </a>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden flex h-10 w-10 items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-background-200/70 bg-background-50/98 backdrop-blur-md px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#library"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
          >
            <i className="ri-search-line"></i>
            开始找片
          </a>
        </nav>
      )}
    </header>
  );
}